import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Discount/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllDiscounts extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Discount/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class DeleteADiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Discount/DeleteBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateADiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Discount/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export { CreateDiscount, GetAllDiscounts, DeleteADiscount, UpdateADiscount };
